import { render, staticRenderFns } from "./img-text-birth-block.vue?vue&type=template&id=2620d9fe&scoped=true&"
import script from "./img-text-birth-block.vue?vue&type=script&lang=js&"
export * from "./img-text-birth-block.vue?vue&type=script&lang=js&"
import style0 from "./img-text-birth-block.vue?vue&type=style&index=0&id=2620d9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620d9fe",
  null
  
)

export default component.exports